import { ReactNode } from 'react'
import cl from 'classnames'

import styles from './styles.module.scss'

interface Props {
  children: ReactNode
  className?: string
}

export const UploadListContainer = ({ children, className }: Props) => {
  return <div className={cl(styles.container, className)}>{children}</div>
}
